import { AbilityBuilder } from "@casl/ability";
import { AppAbility } from "modules/auth";

export const defineRulesForSuperAdmin = (abilityBuilder: AbilityBuilder<AppAbility>) => {
    const { can, rules, cannot } = abilityBuilder;

    can("view", "UserActivityModule");
    can("view", "UserAdministrationModule");
    can("view", "ModulesAdministrationModule");
    can("view", "CommunicationModule");
    can("view", "UserNotificationsModule");

    can("view", "InternalSystemsModule");
    can("view", "ExternalModules");
    can("view", "AdditionalModules");
    can("view", "EducationAnalysis");
    can("view", "SemisAdministrationModule");
    can("view", "SEMIS");
    can("view", "InternalDocumentation");
    can("view", "PIO");
    can("view", "Webtop");
    can("view", "ReportProblem");

    can("view", "Records");
    can("update", "Records");

    cannot("view", "EducationModule");
    cannot("view", "EducationLinks");
    can("view", "EducationDocuments");
    can("update", "EducationDocuments");

    cannot("view", "CourseList");
    can("view", "FarmList");
    can("update", "UserRole");

    can("view", "SystemAdministrationModule");

    can("view", "CourseRegistration");

    can("view", "SuperAdminFilter");
    can("view", "WeatherAlarmToggle");

    can("view", "Codebook");
    can("view", "PhytoView");

    can("view", "Beekeeping");
    can("update", "Beekeeping");

    return rules;
};
